import actions from '@/store/reports/actions';

const reportsModule = {
  state: () => ({
    reports: [],
    total: 0,
  }),
  getters: {
    sortedReports(state) {
      return state.reports ? state.reports.sort((a, b) => b.id - a.id) : [];
    },
  },
  mutations: {
    GET_REPORTS_SUCCESS(state, data) {
      state.reports = data;
    },
    SET_REPORTS_TOTAL(state, total) {
      state.total = total;
    },
  },
  actions,
  namespaced: true,
};

export default reportsModule;
